export const DONATE_ADDNEW_DONATION_SESSION = "DONATE_ADDNEW_DONATION_SESSION";
export const DONATE_UPDATE_DONATION_SESSION = "DONATE_UPDATE_DONATION_SESSION";
export const DONATE_DELETE_DONATION_SESSION = "DONATE_DELETE_DONATION_SESSION";
export const DONATE_GET_ALL_DONATION_SESSION = "DONATE_GET_ALL_DONATION_SESSION";
export const DONATION_GET_ALL_DONETED_USERS = "DONATION_GET_ALL_DONETED_USERS";
export const DONATION_DELETE_DONATED_USER = "DONATION_DELETE_DONATED_USER";